export class KpiBase {
  constructor(className) {
    this._tween = swim.Transition.duration(350);
    this._link = null;

    this._labelSize = '12px sans-serif';
    this._legendSize = '12px sans-serif';

    this._wrap = document.querySelector(`.${className}`);
    this._view = new swim.HtmlAppView(this._wrap);
    this._graphic = new swim.HtmlAppView(this._wrap.querySelector('.graphic'));

    this._canvas = this._graphic.append("canvas");

    this._pie = new swim.PieView()
      .tickColor("#4a4a4a")
      .font("12px sans-serif")
      .textColor("#4a4a4a");
    this._canvas.append(this._pie);
  }

  disconnected() {
    if(this._link) {
      this._link.close();
      this._link = null;
    }
  }

}
